import { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../api';

export default function Verificar() {
  const [codigo, setCodigo]     = useState(['','','','','','']);
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [reenvio, setReenvio]   = useState(false);
  const [countdown, setCountdown] = useState(60);
  const navigate  = useNavigate();
  const location  = useLocation();
  const canvasRef = useRef(null);
  const inputRefs = useRef([]);

  const clienteId    = location.state?.cliente_id || '';
  const nombreEmpresa = location.state?.nombre_empresa || '';
  const correo       = location.state?.correo || '';

  // Countdown reenvío
  useEffect(() => {
    if (countdown <= 0) return;
    const t = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [countdown]);

  // Canvas ondas
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx    = canvas.getContext('2d');
    let animId, t = 0;
    const resize = () => { canvas.width = window.innerWidth; canvas.height = window.innerHeight; };
    resize();
    window.addEventListener('resize', resize);
    const waves = [
      { amp: 55, freq: 0.012, speed: 0.018, phase: 0,   color: 'var(--accent-soft)' },
      { amp: 35, freq: 0.020, speed: 0.025, phase: 2.0, color: 'rgba(109,40,217,0.12)'  },
      { amp: 70, freq: 0.008, speed: 0.012, phase: 4.0, color: 'rgba(124,58,237,0.07)' },
      { amp: 25, freq: 0.030, speed: 0.030, phase: 1.0, color: 'rgba(167,139,250,0.09)'},
    ];
    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      const cy = canvas.height * 0.65;
      waves.forEach(w => {
        ctx.beginPath();
        for (let x = 0; x <= canvas.width; x += 3) {
          const y = cy + Math.sin(x * w.freq + t * w.speed + w.phase) * w.amp
                       + Math.sin(x * w.freq * 2.1 + t * w.speed * 0.6 + w.phase) * (w.amp * 0.35);
          x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
        }
        ctx.strokeStyle = w.color; ctx.lineWidth = 1.8; ctx.stroke();
      });
      t++; animId = requestAnimationFrame(draw);
    };
    draw();
    return () => { cancelAnimationFrame(animId); window.removeEventListener('resize', resize); };
  }, []);

  const handleInput = (i, val) => {
    if (!/^\d*$/.test(val)) return;
    const nuevo = [...codigo];
    nuevo[i] = val.slice(-1);
    setCodigo(nuevo);
    if (val && i < 5) inputRefs.current[i + 1]?.focus();
    if (nuevo.every(d => d !== '')) verificar(nuevo.join(''));
  };

  const handleKeyDown = (i, e) => {
    if (e.key === 'Backspace' && !codigo[i] && i > 0) {
      inputRefs.current[i - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    const text = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    if (text.length === 6) {
      setCodigo(text.split(''));
      verificar(text);
    }
  };

  const verificar = async (codigoStr) => {
    if (codigoStr.length !== 6) return;
    setError(''); setLoading(true);
    try {
      const r = await api.post('/auth/verificar', {
        cliente_id: clienteId,
        codigo: codigoStr,
      });
      localStorage.setItem('token',          r.data.access_token);
      localStorage.setItem('cliente_id',     r.data.cliente_id);
      localStorage.setItem('nombre_empresa', r.data.nombre_empresa);
      navigate('/');
    } catch (err) {
      const msg = err.response?.data?.detail || 'Código incorrecto';
      setError(msg);
      setCodigo(['','','','','','']);
      inputRefs.current[0]?.focus();
    } finally { setLoading(false); }
  };

  const reenviar = async () => {
    if (countdown > 0) return;
    setReenvio(true);
    try {
      await api.post('/auth/reenviar-codigo', { cliente_id: clienteId });
      setCountdown(60);
      setError('');
    } catch { setError('Error reenviando el código'); }
    finally { setReenvio(false); }
  };

  return (
    <div style={{ position: 'relative', minHeight: '100vh', background: 'var(--bg)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>

      <canvas ref={canvasRef} style={{ position: 'fixed', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }} />
      <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: 600, height: 600, borderRadius: '50%', background: 'radial-gradient(circle, var(--accent-soft) 0%, transparent 70%)', pointerEvents: 'none' }} />

      {/* Logo */}
      <div style={{ position: 'relative', zIndex: 10, display: 'flex', alignItems: 'center', gap: 12, marginBottom: 36 }}>
        <img src="/logo.png" alt="InnovaCall" style={{ width: 44, height: 44, borderRadius: 12, objectFit: 'cover' }} onError={e => { e.target.style.display='none'; }} />
        <div style={{ fontFamily: 'Inter,sans-serif', fontWeight: 800, fontSize: 22, color: '#fff' }}>
          Innova<span style={{ color: 'var(--accent-solid)' }}>Call</span>
        </div>
      </div>

      {/* Card */}
      <div style={{
        position: 'relative', zIndex: 10,
        background: 'rgba(13,13,31,0.85)',
        border: '1px solid var(--accent-soft-2)',
        borderRadius: 20, padding: '40px',
        width: '100%', maxWidth: 420,
        backdropFilter: 'blur(20px)',
        boxShadow: '0 24px 80px rgba(0,0,0,0.5)',
        textAlign: 'center',
      }}>
        {/* Ícono */}
        <div style={{ width: 64, height: 64, borderRadius: 16, background: 'linear-gradient(135deg,var(--accent-solid),var(--accent-2))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, margin: '0 auto 20px', boxShadow: '0 8px 24px rgba(124,58,237,0.4)' }}>
          📧
        </div>

        <h1 style={{ fontFamily: 'Inter,sans-serif', fontSize: 24, fontWeight: 800, color: 'var(--text)', marginBottom: 8 }}>
          Verifica tu correo
        </h1>
        <p style={{ fontSize: 13, color: 'var(--text-3)', marginBottom: 8, lineHeight: 1.6 }}>
          Enviamos un código de 6 dígitos a
        </p>
        <p style={{ fontSize: 14, color: 'var(--accent)', fontWeight: 600, marginBottom: 32 }}>
          {correo}
        </p>

        {error && (
          <div style={{ padding: '11px 14px', background: 'rgba(248,113,113,0.08)', border: '1px solid var(--danger-soft)', borderRadius: 10, fontSize: 13, color: 'var(--danger)', marginBottom: 20 }}>
            {error}
          </div>
        )}

        {/* Inputs del código */}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginBottom: 28 }} onPaste={handlePaste}>
          {codigo.map((d, i) => (
            <input
              key={i}
              ref={el => inputRefs.current[i] = el}
              value={d}
              onChange={e => handleInput(i, e.target.value)}
              onKeyDown={e => handleKeyDown(i, e)}
              maxLength={1}
              style={{
                width: 52, height: 60, textAlign: 'center',
                fontSize: 24, fontWeight: 700, fontFamily: 'Inter,sans-serif',
                background: d ? 'var(--accent-soft)' : 'var(--bg)',
                border: `2px solid ${d ? 'var(--accent-solid)' : 'var(--surface)'}`,
                borderRadius: 12, color: 'var(--text)', outline: 'none',
                transition: 'all 0.15s',
              }}
            />
          ))}
        </div>

        {loading && (
          <div style={{ fontSize: 13, color: 'var(--accent-solid)', marginBottom: 16 }}>Verificando...</div>
        )}

        {/* Reenviar */}
        <div style={{ fontSize: 13, color: 'var(--text-3)' }}>
          ¿No llegó el código?{' '}
          {countdown > 0 ? (
            <span style={{ color: 'var(--text-3)' }}>Reenviar en {countdown}s</span>
          ) : (
            <span onClick={reenviar} style={{ color: 'var(--accent-solid)', cursor: 'pointer', fontWeight: 600 }}>
              {reenvio ? 'Enviando...' : 'Reenviar código'}
            </span>
          )}
        </div>

        <div style={{ marginTop: 20, fontSize: 12, color: 'var(--surface-2)' }}>
          El código expira en 15 minutos
        </div>
      </div>
    </div>
  );
}
